import React from 'react';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import {Col, Container, Row} from "react-bootstrap";
import {Trans, withTranslation} from "react-i18next";

// React Components
import Header from '../../../components/Header/Header';
import Card from '../../../components/Card/Card';
import BulletHeader from '../../../components/BulletHeader/BulletHeader';

// CSS Files
import './styles.css';

const MySwal = withReactContent(Swal);

class LeagueSelection extends React.Component {

   constructor(props) {
      super(props);

      this.state = {
         leagues: this.props.formData.leagues
      };

   }

   componentDidMount() {
      if (this.props.formData.is_replication) {
         let leagues = [];
         this.state.leagues.map(league => {
            league.league_categories.map(category => {
               if (category.name === this.props.formData.category) {
                  leagues.push(league)
               }
            })
         });
         this.setState({leagues: leagues})
      }
   }

   render() {
      const { t } = this.props;

      return (
         <div>
            <Header headerBarTitle={t("registration_page.header")} showHeaderExtras showBackButton/>

            <Container className={"desktop"}>
               <Row>
                  <Col className={"pb-3"} xs={12} sm={12}>
                     <BulletHeader text={t("registration_page.league")}/>
                     <p>{t("registration_page.league_note")}</p>
                  </Col>
               </Row>
               <Row>
                  <Col xs={12}>
                     {this.props.formData.is_replication &&
                     <h3 className={"mt-2"}>{t("registration_page.leagues_from_category")}</h3>
                     }

                     {this.props.formData.is_replication &&
                     <div style={{fontSize: '0.9rem'}} className={"alert alert-primary mt-4"} role="alert">
                        <p>
                           <Trans i18nKey="registration_page.leagues_from_category_alert" values={{ leagueCategory: this.props.formData.category }} components={{ strong: <strong /> }} />
                        </p>
                     </div>}
                     <BulletHeader text={t("registration_page.padelbox_league")}/>
                  </Col>
               </Row>

               <Row>
                  {this.state.leagues.map((item, key) => {
                     let league_id = item.id;
                     let league_name = item.name;
                     let clubs = item.clubs;
                     let league_categories = item.league_categories;
                     let league_payment_method = item.league_payment_method;

                     return <Card
                         showClubLocationInfo
                         showClubs={(e) => this.showClubsModal(e, item.all_clubs)}
                         key={key.toString()} href="#"
                         onClick={() => this.submit({league_id, league_name, league_payment_method, league_categories, clubs})} text={item.name}
                     />
                  })}
               </Row>
            </Container>
         </div>
      );
   }

   submit = (data) => {
      this.props.onSubmit(data)
   };

   showClubsModal = (e, clubs) => {
      e.stopPropagation();
      const { t } = this.props;
      let html_str = "<ul style='text-align:left'>";

      clubs.forEach((club) => {
         html_str += `<li>${club.name}</li>`
      })

      html_str += "</ul>";

      MySwal.fire({
         titleText: t("registration_page.where_can_i_play"),
         html: `<p>${t("registration_page.where_can_i_play_note")}</p><br/><p>${html_str}</p>`
      })
   }

}

export default withTranslation()(LeagueSelection);